<template>
  <div class="">
    <ZnBreadcrumb />
    <div class="main-content">
      <div class="innerTopBox">
        <div class="titleBox">
          <div class="left">
            <span class="blueBox"></span>
            <span>订阅服务</span>
          </div>

          <div class="right1">
            <span class="blueBox"></span>
            <span>个人信息</span>
          </div>
        </div>
        <div class="mainBox">
          <div class="left">
            <div style="width: 800px">
              <el-table
                  :header-cell-style="{color: 'rgba(0,0,0,0.93)',fontWeight: 350,height: '60px',}"
                  :data="serverData1" style="width: 100%">
                <el-table-column label="当前版本" prop="context" width="80">
                </el-table-column>
                <el-table-column label="" prop="name" width="150">
                  <template slot="header">
              <span style="background-color: #e7faf0;border-color: #d0f5e0;color: #84d89d;display: inline-block;padding: 0 10px;border-width:1px;
              border-style:solid;border-radius:30px;box-sizing:border-box">{{ this.info.versionText }}</span>
                  </template>
                  <template slot-scope="scope">
                    <div style="width: 190px;">
                      <el-progress color="#84d89d" :show-text="false" :stroke-width="8" :percentage="scope.row.percentage"></el-progress>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="" prop="name" width="150" align="left">
                  <template slot-scope="scope">
                    <!--              <div style="font-size: 14px;color: #a59da2" v-if="scope.row.openStatus == 0"> {{ scope.row.using }} / {{ scope.row.total }} </div>-->
                    <!--              <div style="font-size: 14px;color: #a59da2" v-if="scope.row.openStatus == 1">{{ scope.row.using }} / {{ scope.row.total }}</div>-->
                    <div style="font-size: 14px;color: #a59da2" v-if="scope.row.openStatus < 2" >{{ scope.row.using }} / {{ scope.row.total }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="" prop="openDesc" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.openStatus == 2" style="color: #e3a043">{{scope.row.openDesc}}</span>
                    <span v-else >{{scope.row.openDesc}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="" prop="price" align="center">
                </el-table-column>
                <el-table-column align="center" width="140">
                  <template slot="header">
              <span>
                <el-button size="small" v-if="systemUpgrade == 0 && version < 40" type="primary" @click="paymentSystemUp()" round>升级为专业版</el-button>
              </span>
                  </template>
                  <template slot-scope="scope">
                    <el-button size="mini" v-if="scope.row.openStatus == 0" type="primary" @click="paymentNum(scope.row)" round>加购</el-button>
                    <!--              <el-button v-if="scope.row.openStatus == 0" type="text" @click="paymentNum(scope.row)">购买</el-button>-->
                  </template>
                </el-table-column>
              </el-table>
              <div style="margin-top: 50px;margin-bottom: 50px;font-size: 15px;">
                <!--          <el-divider direction="vertical"></el-divider>-->
                <!--          <span>产品信息</span>-->
                <span></span>
              </div>

              <el-table
                  :header-cell-style="{color: 'rgba(0,0,0,0.93)',fontWeight: 350,height: '60px',}"
                  :data="serverData2" style="width: 100%">
                <el-table-column label="产品名称" prop="context"/>
                <el-table-column label="当前状态" prop="openDesc" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.openStatus == 2" style="color: #e3a043">{{scope.row.openDesc}}</span>
                    <span v-else >{{scope.row.openDesc}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="有效期" prop="expirationDate" width="200" align="center"></el-table-column>
                <el-table-column label="" prop="price" width="200" align="center"></el-table-column>
                <el-table-column label="操作" prop="" align="center" width="140">
                  <template slot-scope="scope">
                    <el-button size="mini" v-if="scope.row.openStatus == 0" type="primary" @click="opened(scope.row)" round>开通</el-button>
                    <!--              <el-button v-if="scope.row.openStatus == 0" type="text" @click="opened(scope.row)">开通</el-button>-->
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="right1">
            <div class="line">
              <span class="leftText">单位名称</span>
              <div class="rightText">{{ info.schoolName }}</div>
            </div>
            <div class="line">
              <span class="leftText">课题组名称</span>
              <div class="rightText">{{ info.taskName }}</div>
            </div>
            <div class="line">
              <span class="leftText">用户身份</span>
              <div class="rightText">
                {{ info.userRole == 1 ? "管理员" : "普通用户" }}
              </div>
            </div>
            <div class="line">
              <span class="leftText">真实姓名</span>
              <div class="rightText">{{ info.nickName }}</div>
            </div>
            <div class="line">
              <span class="leftText">登录帐号</span>
              <div class="rightText">{{ info.accountName }}</div>
              <!--              <span class="editPass cursorPointer" @click="editUserNameFlag = true">修改账号</span>-->
            </div>
            <div class="line">
              <span class="leftText">密码</span>
              <div class="rightText">******</div>
              <span class="editPass cursorPointer" @click="showEdit = true"
              >修改密码</span
              >
            </div>
            <div class="line">
              <span class="leftText">邮箱地址</span>
              <el-input
                  :disabled="!editEmailFlog"
                  style="width: 230px; margin-left: 46px"
                  v-model="info.email"
                  placeholder="请输入（用于接收试剂归还提醒）"
              ></el-input>
              <button
                  @click="editEmailFlog = true"
                  class="smallBtn special cursorPointer"
              >
                修改
              </button>
              <button @click="editEmail" class="smallBtn cursorPointer">
                保存
              </button>
            </div>
            <div class="line">
              <span class="leftText">手机号码</span>
              <el-input
                  :disabled="!editPhoneFlog"
                  style="width: 230px; margin-left: 46px"
                  v-model="info.cellphone"
              ></el-input>
              <button
                  @click="editPhoneFlog = true"
                  class="smallBtn special cursorPointer"
              >
                修改
              </button>
              <button @click="editPhone" class="smallBtn cursorPointer">
                保存
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="centerLine"></div>
      <div class="bottomBoxClass">
        <el-row>
          <el-col :span="7" :offset="1" >
            <div style="text-align: center;line-height: 40px;margin-top: 20px;">
              <span style="font-weight: 700;color: #303133">我的身份码</span>
            </div>
            <div style="text-align: center;">
              <div class="imgBox" >
                <img :src="codeImg" alt="" />
              </div>
            </div>
            <div style="line-height: 100px;text-align: center;">
              <button class="cursorPointer" @click="showGetCode = true" style="background: rgba(71,138,255,.1);color: #478aff;border: none">
                打印二维码
              </button>
            </div>
          </el-col>
          <el-col :span="3" :offset="3" >
            <div >
              <div style="text-align: center;line-height: 40px;margin-top: 20px;width: 180px;">
                <span style="font-weight: 700;color: #303133">我的注册邀请码</span>
              </div>
              <div class="contextUrl">
<!--                <el-input type="textarea" min="4" v-model="info.inviteCode" readonly/>-->
                <div class="inviteCodeShow">{{info.inviteCode}}</div>
              </div>
              <div style="line-height: 100px;text-align: center;padding-top: 60px;width: 180px;">
                <button type="primary" @click="copyInviteCode" style="background: rgba(71,138,255,.1);color: #478aff;border: none">
                  复制
                </button>
              </div>
            </div>
          </el-col>
        </el-row>
<!--        <el-row>-->
<!--          <el-col :span="1"></el-col>-->
<!--          <el-col :span="7">-->
<!--            <div style="text-align: center;line-height: 40px;margin-top: 20px;">-->
<!--              <span style="font-weight: 700;color: #303133">我的身份码</span>-->
<!--            </div>-->
<!--            <div style="text-align: center;">-->
<!--              <div class="imgBox" >-->
<!--                <img :src="codeImg" alt="" />-->
<!--              </div>-->
<!--            </div>-->
<!--            <div style="line-height: 100px;text-align: center;">-->
<!--              <button class="cursorPointer" @click="showGetCode = true" style="background: rgba(71,138,255,.1);color: #478aff;border: none">-->
<!--                打印二维码-->
<!--              </button>-->
<!--            </div>-->
<!--          </el-col>-->
<!--          <el-col :span="1"><div class="grid-content bg-purple-light"></div></el-col>-->
<!--          <el-col :span="7">-->
<!--            <div >-->
<!--              <div style="text-align: center;line-height: 40px;margin-top: 20px;">-->
<!--                <span style="font-weight: 700;color: #303133">邀请组内成员</span>-->
<!--              </div>-->
<!--              <div style="text-align: center;margin-top: 25px;" class="contextUrl">-->
<!--                <el-input type="textarea" autosize v-model="info.inviteCode" readonly/>-->
<!--              </div>-->
<!--              <div style="line-height: 100px;text-align: center;margin-top: 58px;">-->
<!--                <button type="primary" @click="copyInviteCode" style="background: rgba(71,138,255,.1);color: #478aff;border: none">-->
<!--                  复制该链接-->
<!--                </button>-->
<!--              </div>-->
<!--            </div>-->
<!--          </el-col>-->
<!--          <el-col :span="1"><div style="padding: 10px"></div></el-col>-->
<!--          <el-col :span="7" style="">-->
<!--            <div >-->
<!--              <div style="text-align: center;line-height: 40px;margin-top: 20px;">-->
<!--                <span style="font-weight: 700;color: #303133">产品好用，分享给组外朋友</span>-->
<!--              </div>-->
<!--              <div style="text-align: center;margin-top: 25px;" class="contextUrl">-->
<!--                <el-input type="textarea" autosize v-model="info.inviteCode" readonly/>-->
<!--              </div>-->
<!--              <div style="line-height: 100px;text-align: center;margin-top: 58px;">-->
<!--                <button class="cursorPointer" @click="copyInviteCode" style="background: rgba(71,138,255,.1);color: #478aff;border: none">-->
<!--                  复制该链接-->
<!--                </button>-->
<!--              </div>-->
<!--            </div>-->
<!--          </el-col>-->
<!--        </el-row>-->
      </div>
<!--      <div class="bottomBoxClass">-->
<!--        <div class="left">-->
<!--          <div style="text-align: center;line-height: 40px;width: 200px;margin-top: 20px;">-->
<!--            <span style="font-weight: 700;color: #303133">我的身份码</span>-->
<!--          </div>-->
<!--          <div style="text-align: center;margin: auto;line-height: 200px;">-->
<!--            <div class="imgBox" id="printMeCode">-->
<!--              <img :src="codeImg" alt="" />-->
<!--            </div>-->
<!--          </div>-->
<!--          <div style="line-height: 100px;">-->
<!--            <button class="cursorPointer" @click="showGetCode = true">-->
<!--              打印二维码-->
<!--            </button>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="center">-->
<!--          <div style="padding-top: 20px;width: 200px;">-->
<!--            <span style="font-weight: 700;color: #303133">邀请组内成员</span>-->
<!--          </div>-->
<!--          <div id="copy_text">{{ info.invitationUrl }}</div>-->
<!--          <div>-->
<!--            <button class="btn cursorPointer" @click="getUserInfo(true)"/>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="right">-->

<!--        </div>-->

<!--      </div>-->
<!--      <div class="innerBottomBox">-->
<!--        <div class="titleBox">-->
<!--          <span class="blueBox"></span>-->
<!--          <span>邀请组内成员</span>-->
<!--        </div>-->
<!--        <div class="codeLine">-->
<!--          <div class="code" id="copy_text">{{ info.invitationUrl }}</div>-->
<!--          <button class="btn cursorPointer" @click="getUserInfo(true)">-->
<!--            复制该链接-->
<!--          </button>-->

<!--          &lt;!&ndash;           <button class="btn cursorPointer" @click="qrcodeScan()">&ndash;&gt;-->
<!--          &lt;!&ndash;            点击生成邀请码&ndash;&gt;-->
<!--          &lt;!&ndash;          </button>&ndash;&gt;-->
<!--        </div>-->
<!--        <div class="codeLine" >-->
<!--          <div class="bookcode" id="qrcode" ref="qrcode1"></div>-->
<!--          <div class="remark" v-if="qrcodeFlag">*发送给好友进行注册，24小时内有效</div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="innerBottomBox">-->
<!--        <div class="titleBox">-->
<!--          <span class="blueBox"></span>-->
<!--          <span>产品很好用，分享给组外朋友体验</span>-->
<!--        </div>-->
<!--        <div class="codeLine">-->
<!--          <div class="code" id="copy_text">{{ info.otherGroupInvitationUrl }}</div>-->
<!--          <button class="btn cursorPointer" @click="getUserInfo(true,true)">-->
<!--            复制该链接-->
<!--          </button>-->
<!--        </div>-->
<!--        <div class="codeLine" >-->
<!--          <div class="bookcode" id="qrcode" ref="qrcode1"></div>-->
<!--          <div class="remark" v-if="qrcodeFlag">*发送给好友进行注册，24小时内有效</div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <el-dialog class="editDialogClass"
               title="修改密码"
               :visible.sync="showEdit"
               width="542px"
               :show-close="false"
               center
    >
      <div class="formName">原始密码</div>
      <input
          type="password"
          class="formInput"
          placeholder="请输入原始密码"
          v-model="oldPass"
          @focus="currentInputIndex = 0"
          @blur="currentInputIndex = -1"
      />
      <div
          class="inputLine"
          :class="currentInputIndex == 0 ? 'active' : ''"
      ></div>
      <div class="formRamark">*忘记密码请联系管理员重置后修改</div>
      <div class="formName">新密码</div>
      <input
          type="password"
          class="formInput"
          placeholder="请输入新密码"
          v-model="newPass"
          @focus="currentInputIndex = 1"
          @blur="currentInputIndex = -1"
      />
      <div
          class="inputLine"
          :class="currentInputIndex == 1 ? 'active' : ''"
      ></div>
      <div class="formRamark">* 新密码（6-16位字母+数字）</div>
      <div class="formName">新密码确认</div>
      <input
          type="password"
          class="formInput"
          placeholder="请输入新密码"
          v-model="confirmNew"
          @focus="currentInputIndex = 2"
          @blur="currentInputIndex = -1"
      />
      <div
          class="inputLine"
          :class="currentInputIndex == 2 ? 'active' : ''"
      ></div>
      <button class="formBtn cursorPointer" @click="editPass">确认</button>
      <button class="formBtn cursorPointer" @click="showEdit = false">
        取消
      </button>
      <!-- <span>需要注意的是内容是默认不居中的</span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="showEdit = false">取 消</el-button>
            <el-button type="primary" @click="showEdit = false">确 定</el-button>
        </span> -->
    </el-dialog>


    <!-- 打印柜机码弹框 -->
    <el-dialog
        title="身份码"
        :visible.sync="showGetCode"
        class="createDia"
        width="460px"
    >
      <div class="addressBox" id="print2">
        <!-- <img :src="curLocationCode" alt=""> -->
        <div ref="qrcode" class="codeBox">
          <img :src="codeImg" alt="" />
        </div>
        <div class="info">
          <div class="infoText">用户名：{{ info.nickName }}</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showGetCode = false">取 消</el-button>
        <el-button
            type="primary"
            v-print="'#print2'"
            @click="showGetCode = false"
        >确认生成并打印</el-button
        >
      </div>
    </el-dialog>

    <!-- 修改账号 -->
    <el-dialog
        :visible.sync="editUserNameFlag"
        width="460px"
    >
      <div slot="title"  style="margin-left: 150px;font-weight: bold;font-size: 20px">修改账号</div>
      <el-input v-model="newUserName" type="text" placeholder="请输入新的账号" style="margin-top: 10px"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editUserNameFlag= false">取 消</el-button>
        <el-button type="primary" @click="handleEditUserName">确 定</el-button>
      </div>
    </el-dialog>


    <!--    <div >-->
    <!--      <el-dialog title="版本介绍" :visible.sync="versionDetailDialog" width="30%"  :before-close="versionDetailDialogClose">-->
    <!--        <div class="div-item" style="margin-top: 10px;font-size: 16px;font-weight: 500;line-height: 30px;">-->
    <!--          <ul style="list-style: initial;margin-left: 20px;margin-top: 20px" v-show="this.info.taskSalesVersion == 10">-->
    <!--            <li v-for="(item,id) in versionDetails10" :key="id" class="li-item">-->
    <!--              <span :class="item.highLight?'high-light':''">{{item.content}}</span>-->
    <!--            </li>-->
    <!--          </ul>-->
    <!--          <ul style="list-style: initial;margin-left: 20px;margin-top: 20px" v-show="this.info.taskSalesVersion == 40">-->
    <!--            <li v-for="(item,id) in versionDetails40" :key="id" class="li-item">-->
    <!--              <span :class="item.highLight?'high-light':''">{{item.content}}</span>-->
    <!--            </li>-->
    <!--          </ul>-->
    <!--        </div>-->
    <!--      </el-dialog>-->
    <!--    </div>-->

    <div>
      <el-dialog class="subscribeClass" title="订阅服务" :visible.sync="subscribeServerDialog" width="65%"
                 :before-close="subscribeServerDialogClose">
        <el-table
            :header-cell-style="{background: '#f5f5f5',color: 'rgba(0,0,0,0.93)',fontWeight: 350,height: '60px',}"
            :data="serverData1" style="width: 100%">
          <el-table-column label="当前版本" prop="context" width="80">
          </el-table-column>
          <el-table-column label="" prop="name" width="200">
            <template slot="header">
              <span style="background-color: #e7faf0;border-color: #d0f5e0;color: #84d89d;display: inline-block;padding: 0 10px;border-width:1px;
              border-style:solid;border-radius:30px;box-sizing:border-box">{{ this.info.versionText }}</span>
            </template>
            <template slot-scope="scope">
              <div style="width: 190px;">
                <el-progress color="#84d89d" :show-text="false" :stroke-width="8" :percentage="scope.row.percentage"></el-progress>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="" prop="name" width="190" align="left">
            <template slot-scope="scope">
              <!--              <div style="font-size: 14px;color: #a59da2" v-if="scope.row.openStatus == 0"> {{ scope.row.using }} / {{ scope.row.total }} </div>-->
              <!--              <div style="font-size: 14px;color: #a59da2" v-if="scope.row.openStatus == 1">{{ scope.row.using }} / {{ scope.row.total }}</div>-->
              <div style="font-size: 14px;color: #a59da2" v-if="scope.row.openStatus < 2" >{{ scope.row.using }} / {{ scope.row.total }}</div>
            </template>
          </el-table-column>
          <el-table-column label="" prop="openDesc" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.openStatus == 2" style="color: #e3a043">{{scope.row.openDesc}}</span>
              <span v-else >{{scope.row.openDesc}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" width="140">
            <template slot="header">
              <span>
                <el-button size="small" v-if="systemUpgrade == 0 && version < 40" type="primary" @click="paymentSystemUp()" round>升级为专业版</el-button>
              </span>
            </template>
            <template slot-scope="scope">
              <el-button size="mini" v-if="scope.row.openStatus == 0" type="primary" @click="paymentNum(scope.row)" round>购买</el-button>
              <!--              <el-button v-if="scope.row.openStatus == 0" type="text" @click="paymentNum(scope.row)">购买</el-button>-->
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 25px;margin-bottom: 25px;font-size: 15px;">
          <!--          <el-divider direction="vertical"></el-divider>-->
          <!--          <span>产品信息</span>-->
          <span></span>
        </div>

        <el-table
            :header-cell-style="{background: '#f5f5f5',color: 'rgba(0,0,0,0.93)',fontWeight: 350,height: '60px',}"
            :data="serverData2" style="width: 100%">
          <el-table-column label="产品名称" prop="context"/>
          <el-table-column label="当前状态" prop="openDesc" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.openStatus == 2" style="color: #e3a043">{{scope.row.openDesc}}</span>
              <span v-else >{{scope.row.openDesc}}</span>
            </template>
          </el-table-column>
          <el-table-column label="有效期" prop="expirationDate" width="590" align="center">
          </el-table-column>
          <el-table-column label="操作" prop="" align="center" width="140">
            <template slot-scope="scope">
              <el-button size="mini" v-if="scope.row.openStatus == 0" type="primary" @click="opened(scope.row)" round>开通</el-button>
              <!--              <el-button v-if="scope.row.openStatus == 0" type="text" @click="opened(scope.row)">开通</el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>

    <div>
      <el-dialog title="已购项目" :visible.sync="subscribeDataDialog" :before-close="subscribeDataDialogClose">
        <el-table :data="subscribeData">
          <el-table-column property="taskName" label="课题组" width="150"></el-table-column>
          <el-table-column property="functionDesc" label="名称" width="150"></el-table-column>
          <el-table-column property="payUserName" label="申请人" width="200"></el-table-column>
          <el-table-column property="num" label="数量"></el-table-column>
          <el-table-column property="createTime" label="申请时间"></el-table-column>
          <el-table-column property="openStatus" label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.openStatus == 10">开通中</span>
              <span v-if="scope.row.openStatus == 20">已开通</span>
              <span v-if="scope.row.openStatus == 30">开通失败</span>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>

    <div>
      <el-dialog title="购买详情" :visible.sync="paymentReagentDialog" width="30%" :before-close="paymentNumDialogClose">
        <el-form :model="form">
          <el-form-item label="当前牌价:">
            <span style="font-weight: 700;color: #478aff;font-size: 14px">199元 / 1000条试剂</span>
          </el-form-item>
          <el-form-item label="购买数量:">
            <el-input-number v-model="form.reagentNum" :min="1000" :step="1000" :step-strictly="true"></el-input-number>
            <el-input v-model="form.funType" type="hidden"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="paymentNumDialogClose">取 消</el-button>
          <el-button type="primary" @click="purchase">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="购买详情" :visible.sync="paymentUserDialog" width="30%" :before-close="paymentNumDialogClose">
        <el-form :model="form">
          <el-form-item label="当前牌价:">
            <span style="font-weight: 700;color: #478aff;font-size: 14px">99元 / 1人</span>
          </el-form-item>
          <el-form-item label="购买数量:">
            <el-input-number v-model="form.userNum" :min="1" :step="1" :step-strictly="true"></el-input-number>
            <el-input v-model="form.funType" type="hidden"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="paymentNumDialogClose">取 消</el-button>
          <el-button type="primary" @click="purchase">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
//import Clipboard from "clipboard";
import QRCode from 'qrcodejs2'
import {EventBus} from "@/config/event-bus";
export default {
  // components: {QRCode},
  data() {
    return {
      info: {
        versionText: '',
        inviteCode: null,
      },
      systemUpgrade: null,
      version: null,
      paymentReagentDialog: false,
      paymentUserDialog: false,
      subscribeDataDialog: false,
      subscribeServerDialog: false,
      showEdit: false,
      showGetCode: false,
      versionDetailDialog: false,
      currentInputIndex: -1,
      oldPass: "",
      newPass: "",
      confirmNew: "",
      copyBtn: null,
      codeImg: "",
      editEmailFlog: false,
      editPhoneFlog: false,
      qrcodeFlag: false,
      qrcode: null,
      editUserNameFlag: false,
      newUserName: "",
      versionDetails10: [
        {
          highLight: false,
          content: '搜索：搜物性、搜库存、搜在售',
        }, {
          highLight: false,
          content: '采购：三方比价、一键下单、直连库存',
        }, {
          highLight: false,
          content: '库存：简单的登记和出入库管理',
        }, {
          highLight: false,
          content: '试剂共享共建，跨组领借还',
        }, {
          highLight: false,
          content: '经费管理',
        }, {
          highLight: false,
          content: '报表和统计',
        }, {
          highLight: false,
          content: '文档库',
        }, {
          highLight: false,
          content: '20个账号',
        }, {
          highLight: false,
          content: '不限搜索次数',
        }, {
          highLight: false,
          content: '3000试剂库存量',
        },
      ],
      versionDetails40: [
        {
          highLight: false,
          content: '基础版所有功能',
        }, {
          highLight: false,
          content: '智能推荐试剂存放位置以及销毁方法',
        }, {
          highLight: false,
          content: '物联网机械盘点省时省力',
        }, {
          highLight: false,
          content: '增强的历史数据查询',
        }, {
          highLight: false,
          content: '增强的统计报表和分析',
        }, {
          highLight: false,
          content: '支持连接电子实验记录本',
        }, {
          highLight: false,
          content: '支持连接PDA扫码枪、标签打印机(另外采购)',
        }, {
          highLight: false,
          content: '采支持连接蓝牙锁、智能锁开关(另外采购)',
        }, {
          highLight: false,
          content: '合理需求的快速响应和改进',
        }, {
          highLight: false,
          content: '不限用户账号数量',
        }, {
          highLight: false,
          content: '不限试剂库存数量',
        },
      ],
      serverData1: [],
      serverData2: [],
      subscribeData: [],
      form: {
        reagentNum: 1000,
        userNum: 1,
        funType: null,
      },
    };
  },
  created() {
    this.getUserInfo();
    this.getServierConfig();
  },
  computed: {
    passStr() {
      let arr = new Array(this.info.password.length);
      return arr.fill("*").toString();
    },
    currentVersion() {
      var find = this.versionDetails.find(item => item.version === this.info.taskSalesVersion);
      console.log("**"+find.details);
      return find;
    },
  },
  methods: {
    reset() {
      this.form = {
        reagentNum: 1000,
        userNum: 1,
        funType: null,
      }
    },
    handleEditUserName(){
      if (this.newUserName == ""){
        return this.$message.error("账号不能为空");
      }
      this.$apiFetch.post(`/lockerUser/changeAccountName`,{accountName:this.newUserName}).then((res) => {
        if (!res.data.code){
          this.$message.success("修改成功");
          this.editUserNameFlag = false
          this.getUserInfo()
          EventBus.$emit('accountName',this.newUserName);
        }else{
          return this.$message.error(res.data.description);
        }

      })
    },
    qrcodeScan(){
      //生成二维码
      this.qrcode=null;
      let dom = document.getElementById("qrcode");
      while (dom.firstChild) {
        dom.removeChild(dom.firstChild);
      }
      this.qrcode = new QRCode('qrcode', {
        width: 107, //图像宽度
        height: 107, //图像高度
        colorDark: '#000000', //前景色
        colorLight: '#ffffff', //背景色
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.H
      });
      this.qrcode.clear(); //清除二维码
      this.qrcode.makeCode(this.info.invitationUrl);
      this.qrcodeFlag=true;
      this.$message({
        showClose: true,
        message: "邀请码生成成功",
        type: "success",
      });
    },


    copyInviteCode(){
      var input = document.createElement("input");
      input.value = this.info.inviteCode;
      //添加input标签
      document.body.appendChild(input);
      //选中input标签
      input.select();
      //执行复制
      document.execCommand("copy");
      this.$alert('复制成功', '提示', {
        showClose: false,
        confirmButtonText: '确定',
        callback: action => {
        }
      });
      //移除input标签
      document.body.removeChild(input);
    },
    getUserInfo(rebuild,type) {
      if (rebuild) {
        this.$apiFetch.get("/lockerUser/info?rebuild=30").then((res) => {
          this.info = res.data;

          //创建input标签
          var input = document.createElement("input");
          //将input的值设置为需要复制的内容
          input.value = res.data.invitationUrl;
          if(type==1){
            input.value = res.data.otherGroupInvitationUrl;
          }
          //添加input标签
          document.body.appendChild(input);
          //选中input标签
          input.select();
          //执行复制
          document.execCommand("copy");
          //成功提示信息
          // this.$message({
          //   showClose: true,
          //   message: "请将该链接复制到浏览器打开",
          //   type: "success",
          // });
          this.$alert('复制成功', '提示', {
            showClose: false,
            confirmButtonText: '确定',
            callback: action => {
            }
          });
          //移除input标签
          document.body.removeChild(input);
        });

      } else {
        this.$apiFetch.get("/lockerUser/getUserMemberInfo?rebuild=1").then((res) => {
          this.info = res.data;
          this.codeImg = "data:image/png;base64," + res.data.receiveCode;
        });
      }
    },
    editPass() {
      if (!this.oldPass || !this.newPass || !this.confirmNew) {
        this.$message({
          showClose: true,
          message: "请填写完整提交",
          type: "error",
        });
        return;
      }
      if (this.newPass !== this.confirmNew) {
        this.$message({
          showClose: true,
          message: "两次填写新密码不同",
          type: "error",
        });
        return;
      }
      this.$apiFetch
          .post("/lockerUser/changePwd", {
            password: this.oldPass,
            newPassword: this.newPass,
            accountName: this.info.accountName,
          })
          .then((res) => {
            console.log(res);
            if (!res.data.code) {
              this.showEdit = false;
              this.$message({
                showClose: true,
                message: "修改成功",
                type: "success",
              });
              localStorage.setItem("TOKEN", "");
              this.$router.push("/");
            } else {
              this.$message({
                showClose: true,
                message: res.data.description,
                type: "error",
              });
            }
          });
    },
    Print() {
      window.print();
    },
    //修改邮箱地址
    async editEmail() {
      if (!this.info.email) {
        this.$message({
          showClose: true,
          message: "请填写完整提交",
          type: "error",
        });
        return;
      }
      this.$apiFetch
          .post("/lockerUser/updateUserEmail", { email: this.info.email })
          .then((res) => {
            console.log(res);
            if (!res.data.code) {
              this.$message({
                showClose: true,
                message: "修改成功",
                type: "success",
              });
              this.editEmailFlog = false;
            }
          });
    },
    //修改邮箱地址
    async editPhone() {
      if (!this.info.cellphone) {
        this.$message({
          showClose: true,
          message: "请输入手机号码",
          type: "error",
        });
        return;
      }
      this.$apiFetch
          .post("/lockerUser/updateUserPhone", { phone: this.info.cellphone })
          .then((res) => {
            console.log(res);
            if (!res.data.code) {
              this.$message({
                showClose: true,
                message: "修改成功",
                type: "success",
              });
              this.editPhoneFlog = false;
            }
          });
    },

    isEmail(val){
      const reg = /^(\w)+(\.\w+)*@(\w)+((\.\w{2,3}){1,3})$/;
      return reg.test(val)
    },
    subscribeServerDialogClick(){
      this.subscribeServerDialog = true;
      this.getServierConfig();
    },
    getServierConfig(){
      this.$apiFetch.get("/payServer/getServerConfig").then((res) => {
        this.version = res.data.version;
        this.systemUpgrade = res.data.systemUpgrade;
        this.serverData1 = res.data.server1;
        this.serverData2 = res.data.server2;
      })
    },
    getOrderDatas(){
      this.$apiFetch.get("/payServer/getOrderDatas").then((res) => {
        this.subscribeData = res.data;
      })
    },
    versionDetailDialogClose(){
      this.versionDetailDialog = false;
    },
    subscribeServerDialogClose(){
      this.subscribeServerDialog = false;
    },
    paymentNum(row){
      var flag = true;
      if(flag){
        this.$message.success("暂不支持线上开通，请联系客服线下开通！");
        return;
      }
      this.form.funType = row.funType;
      if('ReagentQuantity' == row.funType){
        this.paymentReagentDialog = true;
      }
      if('UserQuantity' == row.funType){
        this.paymentUserDialog = true;
      }
      this.form.funType = row.funType;
    },
    //购买
    purchase(){
      let num = null;
      if('ReagentQuantity' == this.form.funType){
        num = this.form.reagentNum;
      }
      if('UserQuantity' == this.form.funType){
        num = this.form.userNum;
      }
      this.form.num = num;
      this.payServer(this.form);
      this.$message.success("操作成功！");
      //关闭弹框
      this.paymentNumDialogClose();
    },
    //开通
    opened(row){
      var flag = true;
      if(flag){
        this.$message.success("暂不支持线上开通，请联系客服线下开通！");
        return;
      }
      const params = {};
      params.funType = row.funType;
      params.num = 1;
      this.$confirm(
          "确认开通吗?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
      ).then(() => {
        this.payServer(params);
        this.$message.success("操作成功！");
      });
    },
    //购买系统版本升级
    paymentSystemUp(){
      var flag = true;
      if(flag){
        this.$message.success("暂不支持线上开通，请联系客服线下开通！");
        return;
      }



      const params = {};
      params.funType = 'SystemUpgrade';
      this.$confirm(
          "确认升级吗?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
      ).then(() => {
        this.payServer(params);
        this.$message.success("系统版本升级审核中，请稍后！");
      });
    },
    //调用后端购买方法封装
    payServer(params){
      this.$apiFetch.post('/payServer',params)
          .then((res) => {
            this.getServierConfig();
          })
          .catch((error) => {
          })
    },
    subscribeDataClick(){
      this.subscribeDataDialog=true;
      this.getOrderDatas();
    },
    subscribeDataDialogClose(){
      this.subscribeDataDialog = false;

    },
    paymentNumDialogClose(){
      this.paymentUserDialog = false;
      this.paymentReagentDialog = false;
      this.reset();
    },
  },
};
</script>
<style lang="less">
.bottomBoxClass {
    button {
      margin-top: 16px;
      margin-left: 2px;
      width: 110px;
      height: 36px;
      border-radius: 4px;
      border: 1px solid #999999;
      text-align: center;
      line-height: 1;
      color: #333333;
      font-size: 14px;
      background-color: #fff;
    }


  .contextUrl {
    text-align: center;
    margin-top: 15px;
    line-height: 100px;
    width: 180px;
    height: 100px;

    .inviteCodeShow {
      border: none;
      background-color: #f8fafc;
      font-size: 16px;
      font-weight: 500;
      font-weight: 700;
    }
  }

}
</style>
<style lang="less">
.el-icon-vip{
  background: url(../../assets/images/exchange-cny-line1.png) no-repeat;
  /* background-size: cover;*/
}
.el-icon-vip:before{
  content: "替";
  font-size: 16px;
  visibility: hidden;
}


.el-icon-vip{
  font-size: 16px;
}
.el-icon-vip:before{
  content: "\e611";
}



.subscribeClass {
  /deep/ .el-dialog .el-dialog__body {
    padding: 0 100px 40px 22px;
  }
  /deep/ .el-progress__text {
    font-size: 14px;
  }
}

</style>
<style lang="less" scoped>

/deep/.innerTopBox {
  padding: 20px;
  //height: 397px;
  border-radius: 4px;

  .titleBox {
    width: 100%;
    height: 36px;
    border-bottom: 1px solid #eef2f8;
    display: flex;

    span {
      height: 24px;
      font-size: 14px;
      font-weight: 500;
      color: #333333;
      //line-height: 24px;

      &.blueBox {
        width: 3px;
        height: 14px;
        background: #478aff;
        margin-right: 9px;
        position: relative;
        top: 5px;
      }
    }
    .left,
    .right1,
    .right {
      display: flex;
    }

    .left {
      width: 800/1680 * 100%;
    }
    .right1 {
      margin-left: 300/1680 * 100%;
    }
    .right1 {
      flex: 1px;
    }

  }

  .mainBox {
    margin-top: 16px;
    display: flex;

    .left {
      width: 1400/1680 * 100%;
      margin-right: 50/1680 * 100%;
      border-radius: 4px;
      background-color: #ffffff;
      padding: 0 20px;

      .line {
        height: 55px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #eef2f8;
        font-size: 14px;

        &:last-of-type {
          border: none;
        }

        .leftText,
        .rightText {
          height: 20px;
          line-height: 1;
        }

        .leftText {
          width: 70px;
          color: #666;
        }
        .rightText {
          margin-left: 46px;
          color: #333333;
          font-weight: 500;

          input {
            background-color: #fff;
          }
        }
        .editPass {
          margin-left: 64px;
          height: 18px;
          line-height: 1;
          font-size: 12px;
          color: #478aff;
        }

        .levelClass {
          margin-left: 40px;
        }
      }
    }
    .right1 {
      width: 780/1680 * 100%;
      margin-right: 20/1680 * 100%;
      border-radius: 4px;
      background-color: #f8fafc;
      padding: 0 20px;

      .line {
        height: 55px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #eef2f8;
        font-size: 14px;

        &:last-of-type {
          border: none;
        }

        .leftText,
        .rightText {
          height: 20px;
          line-height: 1;
        }

        .leftText {
          width: 70px;
          color: #666;
        }
        .rightText {
          margin-left: 46px;
          color: #333333;
          font-weight: 500;

          input {
            background-color: #fff;
          }
        }
        .editPass {
          margin-left: 64px;
          height: 18px;
          line-height: 1;
          font-size: 12px;
          color: #478aff;
        }

        .levelClass {
          margin-left: 40px;
        }
      }
    }
    .right {
      flex: 1;

      .imgBox {
        margin-top: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 204px;
        height: 204px;
        img {
          width: 187px;
          height: 187px;
        }
      }

      button {
        margin-top: 16px;
        margin-left: 47px;
        width: 110px;
        height: 36px;
        border-radius: 4px;
        border: 1px solid #999999;
        text-align: center;
        line-height: 1;
        color: #333333;
        font-size: 14px;
        background-color: #fff;
      }
    }
  }
}

.centerLine {
  height: 20px;
  background-color: #f2f5fa;
}

.innerBottomBox {
  padding: 20px;
  border-radius: 4px;

  .titleBox {
    width: 100%;
    height: 36px;
    border-bottom: 1px solid #eef2f8;
    display: flex;

    span {
      height: 24px;
      font-size: 14px;
      font-weight: 500;
      color: #333333;
      line-height: 24px;

      &.blueBox {
        width: 3px;
        height: 14px;
        background: #478aff;
        margin-right: 9px;
        position: relative;
        top: 5px;
      }
    }
  }

  .codeLine {
    margin-top: 16px;
    display: flex;

    .code {
      //width: 820/1680*100%;
      //height: 48px;
      padding: 15px 20px;
      line-height: 20px;
      background: #f8fafc;
      border-radius: 4px;

      font-size: 16px;
      color: #333333;
    }

    button {
      width: 155px;
      height: 48px;
      background: rgba(71, 138, 255, 0.1);
      border-radius: 4px;
      line-height: 1;
      font-size: 16px;
      color: #478aff;
      text-align: center;
      margin-left: 20px;
    }
  }

  .remark {
    margin-top: 10px;
    margin-left: 20px;
    height: 18px;
    font-size: 14px;
    color: #999999;
    line-height: 18px;
  }
}

.editDialogClass {
  /deep/ .el-dialog {
    font-size: 14px;

    .el-dialog__header {
      padding-top: 40px;
    }

    .el-dialog__body {
      padding: 0 72px 40px 72px;
    }

    .formName {
      margin-top: 30px;
      height: 20px;
      color: #666666;
      line-height: 20px;

      &:first-of-type {
        margin-top: 40px;
      }

      &:last-of-type {
        color: #333;
      }
    }

    .formInput {
      width: 100%;
      margin-top: 20px;
      height: 20px;
      line-height: 20px;
      background-color: #fff;

      &::placeholder {
        color: #cccccc;
      }
    }

    .inputLine {
      margin-top: 10px;
      height: 1px;
      background: #cccccc;
      transition: all 0.5s ease;

      &.active {
        background: #478aff;
      }
    }

    .formRamark {
      margin-top: 5px;
      height: 18px;
      font-size: 12px;
      color: #999999;
      line-height: 18px;
    }

    .formBtn {
      width: 100%;
      height: 48px;
      color: #999;
      margin-top: 12px;
      background: #f2f5fa;
      border-radius: 4px;
      text-align: center;
      font-size: 18px;
      line-height: 48px;

      &:first-of-type {
        margin-top: 40px;
        background-color: #478aff;
        color: #fff;
      }
    }
  }
}

.createDia {
  /deep/ .el-dialog .el-dialog__body {
    padding: 10px 20px 20px;
  }

  .getCodeBox {
    display: flex;
    width: 100%;
    // background: #f2f5fa;
    border-radius: 4px;

    img {
      width: 150px;
      height: 150px;
    }
  }

  .rBox {
    display: flex;
    flex-direction: column;
    justify-content: center;
    // justify-content: space-between;
    padding: 10px;
  }
}

.smallBtn {
  margin-left: 20px;
  width: 56px;
  height: 28px;
  font-size: 13px;
  background: rgba(71, 138, 255, 0.1);
  border-radius: 4px;
  line-height: 1;
  color: #478aff;
  text-align: center;

  &.special {
    background: #fff;
  }
}

.addressBox {
  display: flex;
  // margin-top: 20px;

  img {
    width: 150px;
    height: 150px;
  }

  .info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 10px;

    .infoText {
      margin-top: 10px;
      color: #000;
      font-weight: 600;
      &:first-of-type {
        margin: 0;
      }
    }
  }
}
</style>